import userReducer from "@/components/search/ducks/reducer"
import internalReducer from "@/components/search/internal/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const searchReducer = combineReducers({
  internal: internalReducer,
  user: userReducer,
})

export default searchReducer
